// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3baXW","noInteraction":"EventWrapper_noInteraction__26rxo"};